import { IAnnualReportTemplateDTO } from '../interfaces/annual-report-template-dto.interface';

export type UpdateAnnualReportTemplateSettingsDto = Pick<IAnnualReportTemplateDTO, 'id' | 'settings'>;
